// Modified version of the original athena-lib version
(function () {
    /* global twttr */

    var currentUrl;
    var _currentSlideshow;
    var slideshows = {};

    var initSlideshows = function () {
        $('.slideshow-card').each(function () {
            var $card = $(this);
            var slid = $card.attr('data-slideshow-id');
            var $overlay = $('#overlay-' + slid);
            var dataUrl = $card.attr('data-data-url');
            var isMobile = $card.hasClass('slideshow-card--mobiweb') || $card.hasClass('slideshow-card--mapi');
            var isMapi = $card.hasClass('slideshow-card--mapi');

            slideshows[slid] = {
                data: null,
                slid: slid,
                dataUrl: dataUrl,
                slideshowOverlay: $overlay,
                autoOpen: parseInt($card.data('opened')),
                overlayHeader: $overlay.find('.slideshow__header'),
                topAd: $overlay.find('.slideshow__ad-con__top-ad'),
                sideAd: $overlay.find('.slideshow__side-ad'),
                preloads: $overlay.find('.slideshow__data__preload'),
                slideThumbsView: $overlay.find('.slideshow__slide__grid-view'),
                slideCountTotal: $overlay.find('.slideshow-counter__total'),
                slideCount: 0,
                slideContainer: $overlay.find('.slideshow__slide__content'),
                slideInstreamAd: $overlay.find('.slideshow__slide-ad__content'),
                slideAdSpinner:  $overlay.find('.slideshow__ad-spinner').slideAdSpinner({totalTime: 4}).data('slideAdSpinner'),
                slideCredit: $overlay.find('.slideshow__slide-credit'),
                slideTitle: $overlay.find('.slideshow__slide-title__text'),
                slideCaption: $overlay.find('.slideshow__slide-caption'),
                slideCounter: $overlay.find('.slideshow-counter__index'),
                slideshowTopSharebar: $overlay.find('.slideshow__header__share'),
                slideSideSharebar: $overlay.find('.slideshow__share-bar'),
                slideIndex: 1,
                preloadCount: 2,
                adsPerSlides: parseInt($overlay.data('mw-slides-per-ad')), // Must always be higher then preloadCount
                adsLockTime: parseFloat($overlay.data('mw-ads-countdown')), // How many seconds we want the user to see the ad
                mobile: isMobile,
                mapi: isMapi, // for mapi you'll have mobile and mapi both true
                desktop: !isMobile,
                adCode: $(this).data('ad-code') || '' // Mobile ad code
            };
        });

        window.addEventListener('keyup', navigateSlides, false);
    };

    var navigateSlides = function (e) {
        if (_currentSlideshow && _currentSlideshow.desktop) {
            switch (e.keyCode) {
                case 27:
                    // escape key
                    _currentSlideshow.slideshowOverlay.find('.slideshow__header__back').click();
                    break;
                case 37:
                    // left arrow
                    _currentSlideshow.slideshowOverlay.find('.slideshow__nav--prev').click();
                    break;
                case 39:
                    // right arrow
                    _currentSlideshow.slideshowOverlay.find('.slideshow__nav--next').click();
                    break;
            }
        }
    };

    var setSlideShareURL = function (currentUrl, ss) {
        if (!ss.mapi) {
            // we add a query string when sharing slideshow urls so that
            // the rails controller can know when we're in slideshow view mode on load
            // (controller can't read hashes, they're not passed to the server)
            var slideshowQueryString = window.Mobileweb.getQueryStringParameter(currentUrl, "slideshow") === undefined ? (currentUrl.indexOf("?") !== -1 ? "&slideshow=true" : "?slideshow=true") : "";
            return currentUrl + slideshowQueryString + "#gallery/" + ss.slid + "/" + ss.slideIndex;
        } else {
            // window.Mobileweb.getQueryStringParameter doesn't work for mapi. We don't have url params there
            return window.location.href.split('#')[0] + "#gallery/" + ss.slid + "/" + ss.slideIndex;
        }
    };

    var initializeEmbeds = function (provider, container) {
        // Initialize embeds if needed.
        if (!provider) return;

        if (provider === 'instagram' && window.instgrm) {
            window.instgrm.Embeds.process();
        } else if (provider === 'twitter' && window.twttr) {
            window.twttr.ready(function () {
                twttr.widgets.load(container);
            });
        }
    };

    function goToSlide(ss, reason) {
        // Shows ads after the current slide if going back.
        var indexForAd = reason === 'prev' ? ss.slideIndex + 1 : ss.slideIndex;

        if (reason !== 'grid' && renderSlideAd(ss, indexForAd)) {
            // An ad was rendered. Don't go to the slide
            ss.slideContainer.empty();
            return;
        }

        var slide = ss.data[ss.slideIndex - 1];
        var isQuoteSlide = slide.type === 'quote';

        invalidateSlideContent(ss, reason);
        initializeEmbeds(slide.provider, ss.slideContainer);

        var slideTitle = isQuoteSlide ? slide.credits || slide.credit || '' : slide.title;
        var slideCaption = slide.text || slide.caption || '';
        var slideCredits = isQuoteSlide ? '' : slide.credits || slide.credit || '';

        ss.slideTitle.html(slideTitle);
        ss.slideCaption.html(slideCaption);
        ss.slideCredit.html(slideCredits);
        ss.slideCounter.html(ss.slideIndex);

        // Avoid styling slide caption  links with entry content styles
        ss.slideCaption.find('a').addClass('entry__link--omit');

        slideshowStateClasses(ss);
        trackSlideshow(ss, slide);
        preloadNextTwoSlides(ss); //pre-load next two slides if they are images

        if (reason === 'open') {
            animateHeader(ss);
        }

        var newUrl = setSlideShareURL(currentUrl, ss);
        window.history.replaceState(null, null, newUrl);

        $(document).trigger('slideshow:gotoSlide', {slideshow: ss});

        //set sharebar individual slide data
        ss.slideSideSharebar.data('sharingimage', slide.image || slide.image_url_large || '');
        ss.slideSideSharebar.data('sharingurl', newUrl);

        triggerReloadSpots(ss);
    }

    function animateHeader(ss) {
        ss.overlayHeader.removeClass('slideshow__header--show');

        setTimeout(function () {
            ss.overlayHeader.addClass('slideshow__header--show');
        }, 0);
    }

    function triggerReloadSpots(ss) {
        if (ss.desktop) {
            $(document).trigger('reloadAd', ss.topAd);
            $(document).trigger('reloadAd', ss.sideAd);
        }
    }

    function validateSlideContent(ss) {
        var $slide = ss.slideContainer;
        var slide = ss.data[ss.slideIndex - 1];
        var preload = ss.preloads[ss.slideIndex - 1];

        if (preload.length && preload.html && typeof preload.html === 'function') {
            $slide.empty().append(preload);
        } else {
            $slide.html(slide.content);
        }
    }

    function invalidateSlideContent(ss, reason) {
        var $slide = ss.slideContainer;
        var enterClass = 'slideshow__slide__content--enter';
        var leaveClass = 'slideshow__slide__content--leave';

        // Stop running animation
        if ($slide.data('slideAnim')) {
            clearInterval($slide.data('slideAnim'));
            $slide.removeClass().addClass('slideshow__slide__content').data('slideAnim', 0);
        }

        switch (reason) {
            case 'open':
                // Only fade in animation on slide enter
                validateSlideContent(ss);
                break;

            case 'grid':
                validateSlideContent(ss);
                animateSlideEnter(ss, enterClass + '-grid', null, 300);
                break;

            default:
                var stateSuffix = reason ? '-' + reason : '';
                animateSlideEnter(ss, enterClass + stateSuffix, leaveClass + stateSuffix);
        }
    }

    /**
     * @param ss
     * @param {string} enterClass
     * @param {string} leaveClass
     * @param {number} [duration] duration in ms. If missing animation-duration from css will be used
     */
    function animateSlideEnter(ss, enterClass, leaveClass, duration) {
        var $slide = ss.slideContainer;
        var slideInTime = parseFloat($slide.css('animation-duration')) * 1000 || duration;
        var queue;

        if (isNaN(slideInTime) || !slideInTime) {
            // There's no slide animation. Replace the slide immediately
            validateSlideContent(ss);
            return;
        }

        if (leaveClass) {
            queue = [
                function () {
                    $slide.addClass(leaveClass);
                },
                function () {
                    validateSlideContent(ss);
                    $slide.removeClass(leaveClass).addClass(enterClass);
                },
                function () {
                    $slide.removeClass(enterClass);
                }
            ];
        } else {
            queue = [
                function () {
                    validateSlideContent(ss);
                    $slide.addClass(enterClass);
                },
                function () {
                    //$slide.removeClass(enterClass);
                    clearInterval($slide.data('slideAnim'));
                }
            ];
        }

        queue = queue.reverse();
        queue.pop().call(this);

        if (queue.length) {
            $slide.data('slideAnim', setInterval(function () {
                queue.pop().call(this);

                if (!queue.length) {
                    clearInterval($slide.data('slideAnim'));
                }
            }, slideInTime));
        }
    }

    function slideshowStateClasses(ss) {
        if (ss.slideIndex === 1) {
            ss.slideshowOverlay
                .removeClass('slideshow--at-last')
                .addClass('slideshow--at-first');
        } else if (ss.slideIndex === ss.slideCount) {
            ss.slideshowOverlay
                .removeClass('slideshow--at-first')
                .addClass('slideshow--at-last');
        } else {
            ss.slideshowOverlay.removeClass('slideshow--at-first slideshow--at-last');
        }
    }

    var trackSlideshow = function (ss, currentSlide) {
        MW.events.publish("tracking_slide_pv", {
            type: "slides_ajax",
            sub_type: 'gallery',
            slideshow_id: ss.slid,
            id: currentSlide.id || currentSlide._id || '',
            pos: ss.slideIndex,
            length: ss.slideCount,
            credit: currentSlide.credit || currentSlide.credits || '',
            slide_type: currentSlide.type,
            slide_filename: currentSlide.image || currentSlide.image_url_large || ''
        });
    };

    var preloadNextTwoSlides = function (ss) {
        for (var i = 1; i <= ss.preloadCount; i++) {
            var newIndex = ss.slideIndex + i;

            if (newIndex < ss.slideCount - 1) {
                var preload = ss.preloads[newIndex];
                var slide = ss.data[newIndex];

                if (!preload.html() && slide.type == 'image') {
                    preload.html(ss.data[newIndex].content);
                }
            }
        }
    };

    var openSlideShow = function (sid, slid, onLoad) {
        if (typeof slid === "undefined") {
            slid = 1; // If not slide is passed open at first
        }

        var ss = slideshows[sid];
        _currentSlideshow = ss;

        if (ss) {
            ss.slideIndex = slid;
            ss.slideshowOverlay.removeClass('hidden');

            if (!ss.slideContainer.data('hammer')) {
                // Attach hammer.js on first open
                ss.slideContainer.hammer({}).on('swipeleft swiperight', onSlidesSwipe);
                ss.slideInstreamAd.hammer({}).on('swipeleft swiperight', onSlidesSwipe);
            }

            $('body').addClass('mobileweb b-page');

            if (!ss.mobile) {
                $('body').addClass('no-scroll');
            }

            $(document).trigger('slideshow:open', {slideshow: ss});

            if (ss.desktop && modulousQueue) {
                modulousQueue.add(function () {
                    ss.topAd.html(Mobileweb.ads.slideshowTop);
                    ss.sideAd.html(Mobileweb.ads.slideshowLeft);
                });
            }

            if (!ss.data) {
                Promise.resolve($.ajaxTraced(ss.dataUrl))
                    .then(function (data) {
                        if (data.slides) {
                            ss.data = data.slides;
                            updateOverlayTitle(ss, data.title);
                            createPreloads(ss);
                            updateSlideCount(ss, data.slides.length);

                            goToSlide(ss, 'open');
                            displaySlideCount(ss, data.length);

                            if (ss.mobile && onLoad) {
                                // When hash is present on mobile open full view
                                onSlideshowFullView.bind(ss.slideshowOverlay)();
                            }
                        }
                    });
            } else {
                goToSlide(ss, 'open');

                if (ss.mobile && onLoad) {
                    // When hash is present on mobile open full view
                    onSlideshowFullView.bind(ss.slideshowOverlay)();
                }
            }

            if (!ss.slideshowTopSharebar.attr('data-sharingurl')) {
                //set sharingurl to slideshow first slide one time
                ss.slideshowTopSharebar.data('sharingurl', setSlideShareURL(currentUrl, ss));
            }
        }
    };

    var updateOverlayTitle = function (ss, title) {
        ss.overlayHeader.find('.slideshow__header__title').html(title);
    };

    var updateSlideCount = function (ss, count) {
        ss.slideCount = count;
    };

    var displaySlideCount = function (ss, count) {
        ss.slideCountTotal.html(count);
    };

    function createPreloads(ss) {
        ss.preloads = [];

        ss.data.forEach(function (slide, index) {
            var $container = $('<div></div>');
            $container.addClass('slide-content slide-type-' + slide.type.replace(/[^a-z0-9-]/gi, ''));

            if (slide.provider) {
                $container.addClass('slide-provider-' + slide.provider.replace(/[^a-z0-9-]/gi, ''));
            }

            $container.html(slide.content);
            ss.preloads.push($container);
        });
    }

    /**
     *
     * @param ss
     * @param {number} adIndex
     * @param {number} [delay]
     * @return {boolean} True if a new ad slide was created
     */
    function createSlideAd(ss, adIndex, delay) {
        var slideAdId = ss.slid + '_' + adIndex;
        var seenAdSpots = ss.slideInstreamAd.data('seenAdSpots');
        var $reactiveAdSpot;

        if (!seenAdSpots) {
            // Update seenAdSpots if it was missing before
            seenAdSpots = {};
            ss.slideInstreamAd.data('seenAdSpots', seenAdSpots);
        }

        var newAdSpot = !seenAdSpots[slideAdId];
        $reactiveAdSpot = $('<div/>', {
            'id': 'mobileweb_instream_square_' + slideAdId,
            'class': 'advertisement mobileweb_slideshow_square treated reactive_ad_spot',
            'data-adcode': ss.adCode
        });

        $reactiveAdSpot.on('click', onAdvertisementSpotClicked);

        seenAdSpots[slideAdId] = true;

        ss.slideInstreamAd.find('.advertisement').detach();
        ss.slideInstreamAd.empty(); // Make sure there are no leftovers
        ss.slideInstreamAd.append($reactiveAdSpot);

        // Let reactive-ads know there was an ad spot added
        $(document).trigger('render:mw-slideshow-ads', {'slideshow_id': ss.slid});

        return newAdSpot;
    }

    function onAdvertisementSpotClicked(e) {
        // If ad content was clicked and not an inner element then there's no ad shown
        if (e.currentTarget === e.target) {
            var ss = findSlideshow($(this).closest('.slideshow'));

            if (ss.slideAdSpinner.isStopped()) {
                // There are no loading ads active
                ss.slideshowOverlay.find('.slideshow__nav--next').click();
            }
        }
    }

    function createThumbs(ss) {
        var $container = ss.slideThumbsView;

        if (!$container.data('thumbs-ready')) {
            $container.empty(); // Remove previous thumbs
            $container.data('thumbs-ready', true);

            ss.data.forEach(function (slide, index) {
                var thumbUrl = slide.image_url_thumb || slide.image || slide.image_url_large;

                // Resize image to the required size
                thumbUrl = replaceUrlParam(thumbUrl, 'ops', '142_142', false);

                var $el = $('<div class="slideshow__slide__thumb yr-slideshow-grid-thumb yr-track"></div>');
                $el.attr('data-slideshow-id', ss.slid);
                $el.attr('data-slide-index', index + 1);

                $el.append('<img src="' + thumbUrl + '" alt="">');
                $container.append($el);
            });
        }
    }

    /**
     * Replaces an url param only if already present
     * @param {string} url
     * @param {string} paramName
     * @param {string} paramValue
     * @param {boolean} [appendMissing=false]
     * @return {string}
     */
    function replaceUrlParam(url, paramName, paramValue, appendMissing) {
        if (paramValue == null) {
            paramValue = '';
        }
        var pattern = new RegExp('\\b('+paramName+'=).*?(&|#|$)');

        if (url.search(pattern) >= 0) {
            return url.replace(pattern,'$1' + paramValue + '$2');
        } else if (appendMissing) {
            url = url.replace(/[?#]$/,'');
            return url + (url.indexOf('?')>0 ? '&' : '?') + paramName + '=' + paramValue;
        }

        return url;
    }

    var checkSlideshowParams = function () {
        // CHECK FOR SLIDESHOW PARAMS
        currentUrl = window.location.href;
        var hash = currentUrl.indexOf("#");
        var slideshowId, slideId;

        if (hash !== -1) {
            var slideshowHashParts = currentUrl.substring(hash + 9, currentUrl.length).split('/');
            slideshowId = slideshowHashParts[0];
            slideId = slideshowHashParts[1];
        }

        for (var slid in slideshows) {
            // If there's a slideshow with auto open override url and open it instead
            // This is used for mapi to auto open a slideshow
            if (slideshows[slid].autoOpen) {
                slideshowId = slid;
                break;
            }
        }

        if (!slideId) {
            slideId = 1;
        }

        if (slideshowId) {
            currentUrl = currentUrl.substring(0, hash);
            openSlideShow(slideshowId, parseInt(slideId, 10), true);
        }
    };

    // Init
    initSlideshows();
    checkSlideshowParams();

    // Event listeners
    $('.slideshow-card').click(function (e) {
        var $card = $(this);
        var $slideshowOverlay = $card.closest('.slideshow-wrapper').find('.slideshow');
        var isMapi = $card.hasClass('slideshow-card--mapi');

        if (!isMapi) {
            // This will get bubble-up click event from overlay, we have to check if event is not from inside overlay
            if ($slideshowOverlay.css('display') === 'none') {
                openSlideShow($(this).attr("data-slideshow-id"));
            }

            e.preventDefault();
            return false;
        }
        // For MAPI case don't open the slideshow and allow the click to go through
    });

    $('.slideshow__slide__content').on('click', onSlideContentClick);
    $('.slideshow__action--share').on('click', onSlideshowShare);
    $('.slideshow__action--grid').on('click', onSlideshowToggleThumbs);
    $('.slideshow__action--full').on('click', onSlideshowFullView);
    $('.slideshow__action--full-exit').on('click', onSlideshowExitFullView);

    $('.slideshow__header__back').click(function (e) {
        var ss = findSlideshow(this);

        if (isGridViewActive(ss)) {
            // Slideshow thumbs grid is visible. Hide it instead of closing the slideshow
            onSlideshowToggleThumbs.call(this);
        } else {
            if (ss.mobile && isFullViewActive(ss)) {
                onSlideshowExitFullView.bind(this)();
            } else {
                ss.slideshowOverlay.addClass('hidden');
                window.history.replaceState(null, null, currentUrl);
                $('body').removeClass('mobileweb b-page no-scroll');
            }
        }
    });

    $('.slideshow__nav--prev').click(function (e) {
        var ss = findSlideshow(this);
        var showingAd = isShowingSlideAd(ss);

        if (ss.slideIndex > 1) {
            if (!showingAd) {
                ss.slideIndex--;
            }

            goToSlide(ss, !showingAd ? 'prev' : '');
        }
    });

    $('.slideshow__nav--next').click(function (e) {
        var ss = findSlideshow(this);
        var showingAd = isShowingSlideAd(ss);

        if (showingAd || ss.slideIndex < ss.slideCount) {
            if (!showingAd) {
                ss.slideIndex++;
            }

            goToSlide(ss, !showingAd ? 'next' : '');
        }
    });

    $('.slideshow__slide__grid-view').on('click', '.slideshow__slide__thumb', onSlideThumbClick);

    ////////////////////

    /**
     * Returns true if an add was shown
     * @param ss
     * @param {number} [slideIndex
     * @return {boolean}
     */
    function renderSlideAd(ss, slideIndex) {
        if (typeof slideIndex === 'undefined') {
            slideIndex = ss.slideIndex;
        }

        var exactAdIndex = slideIndex % ss.adsPerSlides === 0;
        var adRequired = ss.mobile === true && ss.adCode && exactAdIndex;

        if (isShowingSlideAd(ss)) {
            adRequired = false; // We are already showing an ad. Don't show it again.
        }

        if (adRequired) { //add placeholders for slideshow ads
            var isNewAd = createSlideAd(ss, slideIndex / ss.adsPerSlides);
            ss.slideshowOverlay.addClass('slideshow--ad-view');

            if (isNewAd) {
                applyAdLock(ss);
            }

            ss.slideAdSpinner.start();
        } else {
            ss.slideshowOverlay.removeClass('slideshow--ad-view');
            ss.slideAdSpinner.stop();
        }

        return adRequired;
    }

    function applyAdLock(ss) {
        if (ss.adsLockTime > 0) {
            ss.slideshowOverlay.addClass('slideshow--ad-lock');

            setTimeout(function () {
                ss.slideshowOverlay.removeClass('slideshow--ad-lock');
            }, ss.adsLockTime * 1000);
        }
    }

    function onSlideThumbClick(evt) {
        var ss = findSlideshow(this);

        var slideIndex = $(this).data('slide-index');
        ss.slideIndex = parseInt(slideIndex);
        goToSlide(ss, 'grid');
        onSlideshowToggleThumbs.call(this);
    }

    function onSlideContentClick() {
        var ss = findSlideshow($(this).closest('.slideshow'));

        if (ss.mobile && !isFullViewActive(ss)) {
            onSlideshowFullView.call(this);
        }
    }

    function onSlideshowFullView() {
        var ss = findSlideshow($(this).closest('.slideshow'));

        ss.slideshowOverlay.addClass('slideshow--full-view');
        animateHeader(ss);
    }

    function onSlideshowExitFullView() {
        var ss = findSlideshow(this);

        ss.slideshowOverlay.removeClass('slideshow--full-view');
    }

    function onSlideshowShare() {
        var ss = findSlideshow(this);
        ss.slideshowTopSharebar.toggle();
    }

    function onSlideshowToggleThumbs() {
        var ss = findSlideshow(this);

        if (ss.mobile && !isFullViewActive(ss)) {
            ss.slideshowOverlay.addClass('slideshow--full-view');
        }

        createThumbs(ss); // Creates thumbs if missing
        ss.slideContainer.toggle();
        ss.slideThumbsView.toggleClass('hidden');
        ss.slideshowTopSharebar.toggleClass('hidden');
        ss.slideshowOverlay.toggleClass('slideshow--grid-view');
    }

    function isShowingSlideAd(ss) {
        return ss.slideshowOverlay.hasClass('slideshow--ad-view');
    }

    function isInAdLock(ss) {
        return ss.slideshowOverlay.hasClass('slideshow--ad-lock');
    }

    function isGridViewActive(ss) {
        return ss.slideshowOverlay.hasClass('slideshow--grid-view');
    }

    function isFullViewActive(ss) {
        return ss.slideshowOverlay.hasClass('slideshow--full-view');
    }

    function findSlideshow(domElement) {
        return slideshows[$(domElement).data('slideshow-id')];
    }

    function onSlidesSwipe(event) {
        var ss = findSlideshow($(event.target).closest('.slideshow'));

        if (!isInAdLock(ss)) {
            switch (event.type) {
                case 'swipeleft':
                    // Next slide
                    ss.slideshowOverlay.find('.slideshow__nav--next').click();
                    break;

                case 'swiperight':
                    // Previous slide
                    ss.slideshowOverlay.find('.slideshow__nav--prev').click();
                    break;
            }
        }
    }
}());
